import React, { useEffect } from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import { useHistory, useLocation } from "react-router-dom";

const CommonSuccess = () => {
  const location = useLocation();
  const history = useHistory();
  const fromFormSubmission = location.state?.fromFormSubmission;
  const heading = fromFormSubmission ? "Thank you!" : "Success!";
  const message = fromFormSubmission
    ? "Form has been submitted successfully."
    : "Your request was completed successfully.";

  useEffect(() => {
    if (fromFormSubmission) return;
    const reusablePath = sessionStorage.getItem("lastReusableLinkPath");
    if (reusablePath) {
      sessionStorage.removeItem("lastReusableLinkPath");
      history.replace(reusablePath);
    }
  }, [fromFormSubmission, history]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 120px)",
        px: 2,
        py: 4,
        fontFamily: "'Montserrat', sans-serif",
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: 480,
          p: { xs: 3, sm: 5 },
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Stack spacing={2} alignItems="center">
          <Box
            sx={{
              width: 88,
              height: 88,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: (theme) => theme.palette.success.light + "33",
            }}
          >
            <DoneIcon
              sx={{ fontSize: 64, color: "#16a34a" }}
              aria-hidden="true"
            />
          </Box>
          <Typography
            variant="h5"
            component="h1"
            fontWeight={600}
            sx={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {heading}
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {message}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CommonSuccess;
